import styled from 'styled-components'
import { theme } from '@dasa-health/components-react'

export const ResetStyle = styled.div`
    * {
        padding: 0;
        margin: 0;
        border: 0;
        box-sizing: border-box;
    }

    a {
        color: ${theme.colors.primary};
        text-decoration: none;
    }
`

type ContainerType = { innerHeight: number }

export const Container = styled.div`
    ${({ innerHeight }: ContainerType) => `
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;

        height: calc(${innerHeight}px - 48px);

        @media (min-width: ${theme.breakpoints[0]}) {
            height: calc(${innerHeight}px - 64px);
        }
    
        @media screen and (max-height: 450px) {
            height: auto;
        }
  `}
`

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
    max-width: 496px;
    padding: 0 16px;
    height: 100%;

    section {
        align-items: center;
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: center;

        @media screen and (min-width: ${theme.breakpoints[0]}) {
            height: min-content;
        }
    }

    h1 {
        margin: 16px auto 16px auto;
        text-align: center;
    }

    div {
        text-align: center;
        max-width: 379px;

        a {
            display: flex;
            align-items: center;
            justify-content: center;
            left: 0;
        }
    }

    .footer__icon {
        transform: rotate(135deg);
    }
`

export const Illustration = styled.img`
    max-width: 267px;

    @media screen and (max-height: 450px) {
        margin-top: 24px;
    }
`

export const Footer = styled.footer`
    padding-bottom: 24px;
    margin-top: 16px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    height: min-content;

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        justify-content: flex-start;
        padding-top: 40px;
    }
`
